import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'
import { useId } from 'react'

const transition: Transition = {
  duration: 0.8,
  type: 'spring',
  bounce: 0.5,
}

export const Settings = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & {
  isHovered?: boolean
}) => {
  const id = useId()

  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <mask id={id} maskUnits="userSpaceOnUse">
        <rect x="0" y="0" width="20" height="20" fill="white" />

        <motion.circle
          transition={transition}
          variants={{ hover: { cx: 13 } }}
          cx={7}
          cy={5.2}
          r={1.5}
          fill="black"
        />
        <motion.circle
          transition={transition}
          variants={{ hover: { cx: 7 } }}
          cx={13}
          cy={10}
          r={1.5}
          fill="black"
        />
        <motion.circle
          transition={transition}
          variants={{ hover: { cx: 13 } }}
          cx={7}
          cy={14.8}
          r={1.5}
          fill="black"
        />
      </mask>

      <g mask={`url(#${id})`}>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M3.47 5.243h13.056"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M3.47 9.993h13.06"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M3.47 14.743h13.056"
        />
      </g>

      <motion.circle
        transition={transition}
        variants={{ hover: { cx: 13 } }}
        cx={7}
        cy={5.2}
        r={1.5}
        stroke="currentColor"
        strokeWidth={1.3}
      />
      <motion.circle
        transition={transition}
        variants={{ hover: { cx: 7 } }}
        cx={13}
        cy={10}
        r={1.5}
        stroke="currentColor"
        strokeWidth={1.3}
      />
      <motion.circle
        transition={transition}
        variants={{ hover: { cx: 13 } }}
        cx={7}
        cy={14.8}
        r={1.5}
        stroke="currentColor"
        strokeWidth={1.3}
      />
    </motion.svg>
  )
}
